
// 开发服
// const urlSite = {
//     url:'http://10.5.0.13:10002/',
//     site:'z9plus',
//     type:'kf'
// }
// 内网
// const urlSite = {
//     url:'http://192.168.18.133:10027',
//     site:'z9plus',
//     type:'inner net'
// }

// 本地
// const urlSite = {
//     url:'http://127.0.0.1:10027',
//     site:'z9plus'
// }

// 外网測試
// const urlSite = {
//     url:'https://swg-apiserver.swgames01.com',
//     site:'z9plus',
//     type:'outer'
// }

//正式
const urlSite = {
    url:'https://api-server.swggame.com',
    site:'z9plus',
    type:'official'
}

 // <link rel="icon" type="image/x-icon" href="./static/swg.ico">
 // 打包之后记得修改 index.html 添加 .ico文件
export default urlSite



// WEBPACK FOOTER //
// ./src/http.js